import React from 'react';
import { LoginSSOProvidersStyle as S } from './LoginSSOProviders.style';
import { useLoginPageBLoC } from '../../LoginPage.bloc';
import { useObservableState } from 'observable-hooks';
import { PButton } from 'components/prime/PButton/PButton';
import { LinkText } from 'components/LinkText/LinkText';
import { Icon } from 'components/Icon/Icon';

export const LoginSSOProviders: React.FC = () => {
  const { $ssoProviders, back } = useLoginPageBLoC();
  const ssoProviders = useObservableState($ssoProviders);
  return (
    <S.Container>
      <LinkText onClick={back}>
        <Icon icon="chevronLeftLine" color="amber900" size={16} className="block" />
        Back
      </LinkText>
      <S.Title>Select a provider to continue</S.Title>
      <S.InnerContainer>
        {ssoProviders?.map((p) => (
          <PButton
            key={p.id}
            className="w-full"
            severity="secondary"
            label={p.name}
            onClick={() => (window.location.href = p.loginRoute)}
          />
        ))}
      </S.InnerContainer>
    </S.Container>
  );
};
